class App {

  get assetsPath() {
    const hostname = window.location.hostname
    const host = (hostname === 'localhost') ? 'lilyzaproszenia.editello.com' : hostname
    const code = host.split('.')[0]

    return `https://${host}/assets/${code}`
  }

}

const app = new App()

export default app;